export const getProductIdentifierFromUrl = (search = "") => {
  const params = new URLSearchParams(search);
  return (
    params.get("sku") ||
    params.get("id") ||
    params.get("product_ids") ||
    ""
  ).trim();
};

export const parseCouponDiscount = (responseData = {}) => {
  const couponData = responseData?.data || responseData || {};

  let discountPercent =
    responseData?.discount_percent ??
    couponData?.discount_percent ??
    couponData?.percent ??
    null;

  let discountAmount =
    responseData?.discount_amount ??
    couponData?.discount_amount ??
    couponData?.amount ??
    null;

  const discountType = String(
    couponData?.discount_type ??
      couponData?.coupon_discount_type ??
      couponData?.type ??
      ""
  ).toLowerCase();

  const discountValue =
    couponData?.discount_value ??
    couponData?.coupon_discount_amount ??
    couponData?.discount ??
    null;

  const parsedPercent = parseFloat(discountPercent);
  const parsedAmount = parseFloat(discountAmount);
  const hasPercent = !Number.isNaN(parsedPercent) && parsedPercent > 0;
  const hasAmount = !Number.isNaN(parsedAmount) && parsedAmount > 0;

  if (!hasPercent && !hasAmount && discountValue != null && discountValue !== "") {
    const parsedValue = parseFloat(discountValue);
    if (
      discountType.includes("percent") ||
      discountType === "1" ||
      discountType === "percentage"
    ) {
      discountPercent = discountValue;
      discountAmount = "0.00";
    } else if (!Number.isNaN(parsedValue)) {
      discountAmount = discountValue;
      discountPercent = "0.00";
    }
  }

  return {
    code:
      couponData?.code ||
      couponData?.promo_codes ||
      couponData?.promo_code ||
      null,
    discountPercent: discountPercent ?? "0.00",
    discountAmount: discountAmount ?? "0.00",
    discountedPrice:
      couponData?.discounted_price ??
      couponData?.new_price ??
      couponData?.final_price ??
      responseData?.discounted_price ??
      null,
  };
};

export const formatPrice = (number) => {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "USD",
  }).format(number);
};

export const mobileValidate = (number) => {
  const regexpMobile = /^[0-9\b]+$/;
  if (number === "" || regexpMobile.test(number)) {
    return true;
  }
  return false;
};
export const emailValidate = (emailid) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(emailid)) {
    return true;
  }
  return false;
};
export const getUniqueValues = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return ["all", ...new Set(unique)];
};
export const getUniqueValuesHome = (data, type) => {
  let unique = data.map((item) => item[type]);
  if (type === "colors") {
    unique = unique.flat();
  }
  return [...new Set(unique)];
};

export const isValidHttpUrl = (string) => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};
